/*
 * Reading the base from the browser means the token travels with the page:
 * anything named REACT_APP_ is compiled into the JavaScript every visitor
 * downloads, so this token should be scoped to this one base and to reading
 * only. It is not a secret once the site is published.
 */
export const AIRTABLE_API_URL = 'https://api.airtable.com/v0';

export const getAirtableConfig = () => ({
  apiKey: process.env.REACT_APP_AIRTABLE_API_KEY,
  baseId: process.env.REACT_APP_AIRTABLE_BASE_ID,
});

export const isAirtableConfigured = () => {
  const { apiKey, baseId } = getAirtableConfig();
  return Boolean(apiKey && baseId);
};

export const PUBLICATION_CATEGORIES = [
  'Poetry',
  'Essays and Interviews',
  'Anthologies',
  'Podcasts',
];
